/**
 * clipboard へのコピー。成功なら true、失敗なら false を返す (throw しない)。
 *
 * 失敗を握り潰さないための唯一の入口。呼び出し側は必ず結果を見て、失敗を画面に出す
 * (= 「押したのに何も起きない」を作らない)。非セキュア文脈や iframe (AnyCOMPASS 埋め込み)
 * では navigator.clipboard 自体が無く、writeText の参照で TypeError になるため、
 * reject だけでなく同期例外もここで受ける。
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
